import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const surveyRunMap = new Map();

surveyRunMap.set(KnowEdmTableData.DepthMD, {
  key: KnowEdmTableData.DepthMD,
  label: RecognisedHeaderLabels.DepthMD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  label: RecognisedHeaderLabels.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

surveyRunMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  label: RecognisedHeaderLabels.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

surveyRunMap.set(KnowEdmTableData.DepthTVD, {
  key: KnowEdmTableData.DepthTVD,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunMap.set(KnowEdmTableData.Easting, {
  key: KnowEdmTableData.Easting,
  label: RecognisedHeaderLabels.Easting,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunMap.set(KnowEdmTableData.Northing, {
  key: KnowEdmTableData.Northing,
  label: RecognisedHeaderLabels.Northing,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
});

surveyRunMap.set(KnowEdmTableData.LocalPositionEW, {
  key: KnowEdmTableData.LocalPositionEW,
  label: RecognisedHeaderLabels.LocalPositionEW,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

surveyRunMap.set(KnowEdmTableData.LocalPositionNS, {
  key: KnowEdmTableData.LocalPositionNS,
  label: RecognisedHeaderLabels.LocalPositionNS,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

surveyRunMap.set(KnowEdmTableData.VerticalSection, {
  key: KnowEdmTableData.VerticalSection,
  label: RecognisedHeaderLabels.VerticalSection,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

surveyRunMap.set(KnowEdmTableData.Dogleg, {
  key: KnowEdmTableData.Dogleg,
  label: RecognisedHeaderLabels.Dogleg,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

surveyRunMap.set(KnowEdmTableData.Build, {
  key: KnowEdmTableData.Build,
  label: RecognisedHeaderLabels.Build,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

surveyRunMap.set(KnowEdmTableData.Turn, {
  key: KnowEdmTableData.Turn,
  label: RecognisedHeaderLabels.Turn,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
});

surveyRunMap.set(KnowEdmTableData.ToolFace, {
  key: KnowEdmTableData.ToolFace,
  label: RecognisedHeaderLabels.ToolFace,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
});

surveyRunMap.set(KnowEdmTableData.SurveyDate, {
  key: KnowEdmTableData.SurveyDate,
  label: RecognisedHeaderLabels.SurveyDate,
  unit: '',
  quantity: '',
});

surveyRunMap.set(KnowEdmTableData.SurveyStatus, {
  key: KnowEdmTableData.SurveyStatus,
  label: RecognisedHeaderLabels.SurveyStatus,
  unit: '',
  quantity: '',
});

export {
  surveyRunMap,
};
